// extracted by mini-css-extract-plugin
export default {"menu":"manuals_menu__yfTHy","name":"manuals_name__Bmc5+","page":"manuals_page__ZON9Z","mocItem":"manuals_mocItem__GtJS1","manualLink":"manuals_manualLink__CmegJ"};